import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfUse from "./components/TermsOfUse";
import AllInOneHome from "./pages/AllInOneHome";
import LeadGenHome from "./pages/LeadGenHome";
import ClientHome from "./pages/ClientHome";
import ScrollToTop from "./components/ScrollToTop";
import MetaTagsUpdater from "./components/MetaTagsUpdater"; // Import the new component
import { EventPage } from "./components/EventPage";
import PublicPreview from "./pages/PublicPreview";
// import PublicPreviewV2 from "./components/PublicPreviewV2";
import FreeQuizMagnet from "./components/Magnets/FreeQuizMagnet";
import EbookMagnet from "./components/Magnets/EbookMagnet";
import FunnelTemplateMagnet from "./components/Magnets/FunnelTemplateMagnet";
import WebinarMagnet from "./components/Magnets/WebinarMagnet";
import GiftsPage from "./pages/GiftsPage";
import PublicPreviewHT from "./pages/PublicPreviewHT/index";
import BlogDetails from "./pages/BlogDetails";
import BlogPage from "./pages/BlogPage";
import { Analytics } from '@vercel/analytics/react';

function App() {
  return (
    <Router>
      {/* Add ScrollToTop and MetaTagsUpdater just inside the Router */}
      <ScrollToTop />
      <MetaTagsUpdater />
      <Routes>
        <Route path="/" element={<LeadGenHome />} />
        <Route path="/all-in-one-coaching" element={<AllInOneHome />} />
        <Route path="/client" element={<ClientHome />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/event/*" element={<EventPage />} />
        <Route path="/ht_phyt" element={<PublicPreviewHT />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:id" element={<BlogDetails />} />
        {/* <Route path="/ht_phyt" element={<PublicPreviewV2 />} /> */}
        <Route path=":userName" element={<PublicPreview />} />
        <Route path="/gifts" element={<GiftsPage />} />
        <Route path="/gifts/free-quiz" element={<FreeQuizMagnet />} />
        <Route path="/gifts/ebook" element={<EbookMagnet />} />
        <Route path="/gifts/funnel-template" element={<FunnelTemplateMagnet />} />
        <Route path="/gifts/webinar" element={<WebinarMagnet />} />
      </Routes>
      <Analytics />
    </Router>
  );
}

export default App;
